import { render, staticRenderFns } from "./TouFang.vue?vue&type=template&id=796f6964&scoped=true&"
import script from "./TouFang.vue?vue&type=script&lang=js&"
export * from "./TouFang.vue?vue&type=script&lang=js&"
import style0 from "./TouFang.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TouFang.vue?vue&type=style&index=1&id=796f6964&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796f6964",
  null
  
)

export default component.exports